var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon",class:[ 'icon--' + _vm.type, _vm.size && 'icon--' + _vm.size, _vm.isFixed && 'icon--fw'],attrs:{"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.icon(_vm.type))}})}
var staticRenderFns = []

export { render, staticRenderFns }